<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a [routerLink]="['/home']">Home</a>
              </li>
            <li class="breadcrumb-item">
                <a [routerLink]="['/customers']">Customers</a>
            </li>
            <li class="breadcrumb-item" *ngIf="customer">
                <a>{{ customer.customerName || "Customer" }}</a>
            </li>
        </ol>
    </div>
</div>

<div class="wrapper wrapper-content  animated fadeInRight">
    <div class="row">
        <div class="col-lg-8 col-md-12">
            <div class="card mt-2 bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <div class="d-flex fw-bold small">
                        <span class="flex-grow-1">
                            <h5>Customer Products</h5>                        
                        </span>   
                        <span>
                            <button class="btn btn-primary btn-sm" (click)="openProductInstanceModal()">Add Product Instance</button>
                        </span>
                    </div> 
                </div>
                <div class="card-body">
                    <ng-table [tableKeys]="productTableKeys" [tableRows]="productInstancesFormatted" (replaceRowEvent)="replaceProductInstance($event)" (selectRowEvent)="selectProductInstance($event)" (deleteRowEvent)="deleteProductInstance($event)"></ng-table>
                </div>
            </div>
        </div>

        <div class="col-lg-4 col-md-12">
            <div class="card mt-2 bg-red bg-opacity-5">
                <div class="card-header">
                    <h5>Customer Alerts</h5>
                </div>
                <div class="card-content bg-opacity-5 bg-white">
                    <app-alerts [alerts]="productAlerts"></app-alerts>
                </div>
            </div>
        
            <div class="card mt-3 bg-emphasis bg-opacity-25" *ngIf="owners">
                <div class="card-header">
                    <h5>Owners</h5>
                </div>
                <div class="card-content bg-opacity-5 bg-white users">
                    <table *ngIf="owners && owners.length > 0" class="table table-striped">
                        <tr>
                            <th>User</th>
                            <th>Activity Score</th>
                            <th>Last Activity</th>
                        </tr>
                        <tr *ngFor="let owner of owners">
                            <td>{{owner.displayName}}</td>
                            <td>{{owner.usageCounter}}</td>
                            <td>{{owner.lastLogin | relativeDate}}</td>
                        </tr>
                    </table>
                    <div *ngIf="owners == null || owners.length == 0" class="users-none">
                        <span>No Owners</span>
                    </div>
                </div>
            </div>
        
            <div class="card mt-3 bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <h5>Top Users</h5>
                </div>
                <div class="card-content bg-opacity-5 bg-white users">
                    <table *ngIf="activeUsers && activeUsers.length > 0" class="table table-striped">
                        <tr>
                            <th>User</th>
                            <th>Activity Score</th>
                            <th>Last Login</th>
                        </tr>
                        <tr *ngFor="let owner of activeUsers">
                            <td>{{owner.displayName}}</td>
                            <td>{{owner.usageCounter}}</td>
                            <td>{{owner.lastLogin | relativeDate}}</td>
                        </tr>
                    </table>
                    <div *ngIf="activeUsers == null || activeUsers.length == 0" class="users-none">
                        <span>No Users</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" bsModal #productInstanceModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="closeProductInstanceModal()">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">Create Product Instance</h4>
                
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeProductInstanceModal()"></button>
            </div>
            <!-- Form -->
            <form class="modal-form" (ngSubmit)="createProductInstance()" [formGroup]="productGroupModel">
                <div class="modal-body">
                    <div class="form-group row" [class.has-error]="productGroupModel.controls['productId'].invalid && productGroupModel.controls['productId'].touched">
                        <label class="col-sm-4 col-form-label">Product</label>
                        <div class="col-sm-8">
                            <select class="form-select" formControlName="productId">
                                <option *ngFor="let product of products" [value]="product.productId">{{ product.productName }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row" [class.has-error]="productGroupModel.controls['instanceName'].invalid && productGroupModel.controls['instanceName'].touched">
                        <label class="col-sm-4 col-form-label">Instance Name</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" formControlName="instanceName"/>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" type="button" (click)="closeProductInstanceModal()">Cancel</button>
                    <button class="btn btn-primary" type="submit" [disabled]="!productGroupModel.valid">Create Product Instance</button>
                </div>
            </form>
        </div>
    </div>
</div>